/**Dependencies */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
/**Components */
import { Row, Col, Image, Nav, NavLink, Navbar } from "react-bootstrap";

/**Images */
import logoBanner from "../images/logo_footer.png";
import logoMC from "../images/icons/MasterCard.png";
import logoAmex from "../images/icons/American Express.png";
import logoSpei from "../images/icons/SPEI.png";
import logoBbva from "../images/icons/BBVA.png";
import logoVisa from "../images/icons/Visa.png";
import logoPaypal from "../images/icons/Paypal.png";
import logoFB from "../images/icons/Facebook.png";
import logoTT from "../images/icons/TikTok.png";
import logoInsta from "../images/icons/Instagram.png";
import bannerFooter from "../images2/banners/banner_footer.png";
/**Styles */
import "../styles/footer.scss";

/**Componente para renderizar el footer*/
export const Footer = () => {
  const [showSecciones, setShowSecciones] = useState(true);
  const isMobile = window.innerWidth <= 430;

  return (
    <>
      <footer className="bg-footer text-white">
        <div className="container bg-footer-secctions pt-5">
          <Row>
            <Col lg={4} md={12} sm={12} className="mt-5">
              <div className="d-flex justify-content-center p-4">
                <Navbar.Brand
                  as={Link}
                  to={"/"}
                >
                  <Image
                    src={logoBanner}
                    alt="company_logo"
                    rounded
                    className="img-logo-footer"
                  />
                </Navbar.Brand>
              </div>
              <Col lg={12}>
                <Row>
                  <Col xs={4} className="mt-3 text-center">
                    <img src={logoVisa} alt="logo_visa" width={45} />
                  </Col>
                  <Col xs={4} className="mt-3 text-center">
                    <img src={logoAmex} alt="logo_amex" width={55} />
                  </Col>
                  <Col xs={4} className="mt-3 text-center">
                    <img src={logoMC} alt="logo_mc" width={35} />
                  </Col>
                  <Col xs={4} className="mt-3 text-center">
                    <img src={logoSpei} alt="logo_spei" width={35} />
                  </Col>
                  <Col xs={4} className="mt-3 text-center">
                    <img src={logoPaypal} alt="logo_paypal" width={55} />
                  </Col>
                  <Col xs={4} className="mt-2 text-center">
                    <img src={logoBbva} alt="logo_bbva" width={45} />
                  </Col>
                </Row>
              </Col>
            </Col>
            <Col lg={6} md={12} sm={12} className="mt-4 secciones-md-right">
              <h5
                className="mx-3"
              >Secciones
              </h5>

              {(!isMobile || showSecciones) && (
                <Row>
                  <Col>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="w-100 w-md-50">
                        <Nav className="flex-column fs-5">
                          {[
                            { to: "/", text: "Home" },
                            { to: "/hoteles", text: "Hoteles" },
                            { to: "/experiencias", text: "Experiencias" },
                            { to: "/circuitos", text: "Circuitos" },
                            { to: "/traslados", text: "Traslados" },
                            { to: "/renta-autos", text: "Renta de Autos" },
                          ].map((item, idx) => (
                            <NavLink
                              key={idx}
                              className="text-white text-sm mb-2"
                              as={Link}
                              to={item.to}
                              onClick={() =>
                                window.scroll({ top: 0, behavior: "smooth" })
                              }
                            >
                              {item.text}
                            </NavLink>
                          ))}
                        </Nav>
                      </div>
                      <div className="w-100 w-md-50">
                        <Nav className="flex-column fs-5">
                          {[
                            {
                              to: "/terminos-y-condiciones",
                              text: "Términos y Condiciones",
                            },
                            {
                              to: "/politica-de-cookies",
                              text: "Política de Cookies",
                            },
                            {
                              to: "/politica-de-privacidad",
                              text: "Políticas de Privacidad",
                            },
                            {
                              to: "/preguntas-frecuentes",
                              text: "Preguntas Frecuentes",
                            },
                            { to: "/nosotros", text: "Nosotros" },
                          ].map((item, idx) => (
                            <NavLink
                              key={idx}
                              className="text-white text-sm mb-2"
                              as={Link}
                              to={item.to}
                              onClick={() =>
                                window.scroll({ top: 0, behavior: "smooth" })
                              }
                            >
                              {item.text}
                            </NavLink>
                          ))}
                        </Nav>
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
            <Col lg={2} md={12} sm={12} className="text-center">
              <h5 className="mt-3 mb-3">Síguenos en</h5>

              <div>
                <Row className="justify-content-center">
                  <Col xs="3" className="d-flex justify-content-center mb-2">
                    <NavLink
                      className="text-white"
                      as={Link}
                      to="https://www.facebook.com/agenciamarzah/?locale=es_LA"
                    >
                      <img
                        src={logoFB}
                        alt="Facebook"
                        style={{ width: "10px" }}
                      />
                    </NavLink>
                  </Col>
                  <Col xs="3" className="d-flex justify-content-center mb-2">
                    <NavLink
                      className="text-white"
                      as={Link}
                      to="https://www.tiktok.com/@agenciamarzah?is_from_webapp=1"
                    >
                      <img
                        src={logoTT}
                        alt="TikTok"
                        style={{ width: "18px" }}
                      />
                    </NavLink>
                  </Col>
                  <Col xs="3" className="d-flex justify-content-center mb-2">
                    <NavLink
                      className="text-white"
                      as={Link}
                      to="https://www.instagram.com/agenciamarzah"
                    >
                      <img
                        src={logoInsta}
                        alt="Instagram"
                        style={{ width: "18px" }}
                      />
                    </NavLink>
                  </Col>
                  <Col xs="3" className="d-flex justify-content-center mb-2">
                    <NavLink
                      className="text-white"
                      as={Link}
                      to="mailto:ventas@agenciamarzah.com"
                    >
                      <IoMdMail style={{ fontSize: "20px" }} />
                    </NavLink>
                  </Col>
                </Row>
                <div className="mt-4 text-center">
                  <a
                    href="tel:+9982189740"
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    <FaPhoneAlt /> 998 218 9740
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div style={{ width: "100%" }}>
          <Col className="d-flex justify-content-center py-3">
            <span
              style={{ fontSize: "14px", color: "white", fontWeight: "bold" }}
            >
              © 2025 Marzah. Todos los derechos reservados.
            </span>
          </Col>
        </div>
        <div
          style={{
            width: "100%",
            backgroundImage: `url(${bannerFooter})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "20px",
          }}
        ></div>
      </footer>
    </>
  );
};
